import { render, staticRenderFns } from "./community-helper.vue?vue&type=template&id=3f8b0d2c&scoped=true"
import script from "./community-helper.vue?vue&type=script&lang=js"
export * from "./community-helper.vue?vue&type=script&lang=js"
import style0 from "./community-helper.vue?vue&type=style&index=0&id=3f8b0d2c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b0d2c",
  null
  
)

export default component.exports